import React, { useState } from 'react'
import PropTypes from 'prop-types'

import add from 'images/add.svg'
import disabledAddIcon from 'images/disabled-add-icon.svg'

import Form from 'component/utils/Form'
import Modal from 'component/Modal/GenericModal'
import TextField from 'component/TextField'
import Select from 'component/Select/Select'

const FIELDS = ['params', 'type']

const DEFAULT_EDIT_INITIAL_VALUES = {
  params: [
    {
      dsJustification: '',
      inInactive: 0,
    },
  ],
}

const ModalNewJustification = ({
  closeModal,
  handleFilters,
  fields,
  translate,
}) => {
  const filterTypeOptions = [
    {
      value: 0,
      param: 'request',
      label: translate('demarcate.justifies.type.request'),
    },
    {
      value: 1,
      param: 'reproval',
      label: translate('demarcate.justifies.type.reproval'),
    },
  ]

  const [params, setParams] = useState([
    { ...DEFAULT_EDIT_INITIAL_VALUES.params[0] },
  ])
  const [typeValue, setTypeValue] = useState(null)

  const hasAnyEmptyField = () => params.some((j) => !j.dsJustification.trim())

  function handleTypeOption(value) {
    setTypeValue({
      ...filterTypeOptions[value],
    })
  }

  function handleCloseModal() {
    setParams([{ ...DEFAULT_EDIT_INITIAL_VALUES.params[0] }])
    closeModal()
  }

  function submitNewJustifications() {
    const filteredValues = params.filter(
      (item) => item.dsJustification.trim().length > 0
    )
    handleFilters({
      justifies: {
        type: typeValue,
        values: filteredValues,
      },
    })
    setParams([{ ...DEFAULT_EDIT_INITIAL_VALUES.params[0] }])
  }

  const createField = (item, i) => {
    const dsJustification = item.dsJustification.trim()
    return (
      <div className='w-100' key={i}>
        <TextField
          {...fields.params.input}
          className='form-control no-change-color'
          fill
          label={translate('justification')}
          maxLength={50}
          onChange={(event) => {
            const newParams = [...params]
            item.dsJustification = event.target.value.trim()
            setParams(newParams)
          }}
          placeholder={translate(
            'demarcate.justifies.editModal.textField.placeholder'
          )}
          required
          value={dsJustification}
        />
      </div>
    )
  }
  return (
    <Modal
      buttonClass='half-w'
      cancelButtonText={translate('button.cancel')}
      center={false}
      confirmButtonText={translate('register_button')}
      isConfirmButtonDisabled={
        typeValue === null ||
        !params.some((item) => item.dsJustification.trim().length > 0)
      }
      isOpen
      size='md'
      disabledBgClickClosing
      title={translate('demarcate.justifies.ModalNewJustification.title')}
      onCloseModal={() => handleCloseModal()}
      onConfirm={() => submitNewJustifications()}
    >
      <div className='type-demarcate-justification'>
        <Select
          fill
          required
          label={translate('type')}
          options={filterTypeOptions}
          placeholder={translate(
            'demarcate.justifies.ModalNewJustification.select.placeholder'
          )}
          onChange={({ value }) => handleTypeOption(value)}
        />
      </div>

      {params.length > 0 && <div>{params.map(createField)}</div>}
      <div
        className={hasAnyEmptyField() ? 'add-item-disabled' : 'add-item'}
        onClick={
          hasAnyEmptyField()
            ? () => {}
            : () =>
                setParams([...params, { dsJustification: '', inInactive: 0 }])
        }
      >
        <img src={hasAnyEmptyField() ? disabledAddIcon : add} />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <div>
          <span>
            {translate('missionMenu.addModal.field.dsJustification.add')}
          </span>
        </div>
      </div>
    </Modal>
  )
}

ModalNewJustification.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  handleFilters: PropTypes.func,
  fields: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Form({ fields: FIELDS })(ModalNewJustification)

export { ModalNewJustification }
